import type { JSX } from 'react';

import { Product } from '@/hooks/use-jurisdiction';

export const LOG_TAG = '[TermsAndConditions]';

export type ShowTncSheet = (onAccepted: () => void) => void;

export type TermsContentProps = {
    hasAcceptedTerms: boolean;
    handleToggle: () => void;
    handleAcceptPress: () => void;
    handleWebViewOpened: () => void;
    handlePress: () => void;
};

export type TermsContentRenderer = (params: TermsContentProps) => JSX.Element;

export type Verticals = 'FANTASY' | 'SWEEPS_CASH' | 'SWEEPS_COIN' | 'ARCADE' | 'PREDICTION' | 'TRADING_CARDS';

export const PRODUCT_TO_TERMS_VERTICALS: Record<Product, Verticals[]> = {
    pickem: ['FANTASY'],
    sweeps: ['SWEEPS_CASH', 'SWEEPS_COIN'],
    arcade: ['ARCADE'],
    casino: ['SWEEPS_CASH', 'SWEEPS_COIN'],
    prediction: ['PREDICTION'],
    rips: ['TRADING_CARDS'],
    none: [],
};
